import { useRouteError } from 'react-router';
import { useState } from 'react';
import { Loader } from '@components/loader';
import { isChunkLoadError, reloadForNewVersion } from '@utils/chunkReload';
import { ErrorFallback } from './errorFallback';

export const RouteErrorFallback = () => {
  const error = useRouteError();
  const [reloading] = useState(() => isChunkLoadError(error) && reloadForNewVersion());

  if (reloading) return <Loader />;

  return (
    <ErrorFallback
      error={error instanceof Error ? error : new Error(String(error))}
      resetErrorBoundary={() => window.location.reload()}
    />
  );
};
